'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isExpanded", "heading", "isFocus", "children"];
import React, { useContext } from 'react';
import { BrowserDefaultFocusStyleContext } from "../../contexts/BrowserDefaultFocusStyleContext.mjs";
import { KeyboardDetectionContext } from "../../contexts/KeyboardDetectionContext.mjs";
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { HeadingElement } from "./HeadingElement.mjs";
import { AccordionIcon } from "./Icon.mjs";
import { TitleButton } from "./TitleButton.mjs";
import { TitleText } from "./TitleText.mjs";
/**
 * Title of the accordion component, seen on open and closed views.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-accordion-accordiontitle--docs) |
 * [Encore site](https://encore.spotify.net/web/components/accordion) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/AccordionTitle) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?node-id=4037-6864)
 */
export var AccordionTitle = /*#__PURE__*/React.forwardRef(function AccordionTitle(_ref, ref) {
  var _ref$isExpanded = _ref.isExpanded,
    isExpanded = _ref$isExpanded === void 0 ? false : _ref$isExpanded,
    _ref$heading = _ref.heading,
    heading = _ref$heading === void 0 ? 'h2' : _ref$heading,
    isFocus = _ref.isFocus,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useContext = useContext(KeyboardDetectionContext),
    isUsingKeyboard = _useContext.isUsingKeyboard;
  var _useContext2 = useContext(BrowserDefaultFocusStyleContext),
    useBrowserDefaultFocusStyle = _useContext2.useBrowserDefaultFocusStyle;
  return /*#__PURE__*/React.createElement(HeadingElement, {
    heading: heading,
    ref: ref
  }, /*#__PURE__*/React.createElement(TitleButton, Object.assign({
    $isUsingKeyboard: isUsingKeyboard,
    $useBrowserDefaultFocusStyle: useBrowserDefaultFocusStyle,
    $isFocus: isFocus,
    "aria-expanded": isExpanded
  }, props, {
    "data-encore-id": ENCORE_DATA_IDS.AccordionTitle
  }), /*#__PURE__*/React.createElement(TitleText, {
    variant: "titleSmall"
  }, children), /*#__PURE__*/React.createElement(AccordionIcon, {
    $isExpanded: isExpanded,
    semanticColor: "textSubdued",
    "aria-hidden": "true",
    role: "presentation"
  })));
});